import { createContext, useContext, useState, useEffect } from "react";

const NewEventContext = createContext();

const useNewEvent = () => useContext(NewEventContext);

const NewEventProvider = ({ children }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [event, setEvent] = useState(null);


   const createNewEvent = (dateTime, stylist) => {
    console.log(stylist, "stylist");
    setEvent({timestamp: dateTime, stylist})
    setOpenDialog(true)
  }

  const editEvent = (eventId) => {
    setEvent({appointment_id: eventId})
    setOpenDialog(true)
  } 

  let value = {
    openDialog,
    setOpenDialog,
    event,
    setEvent,
    createNewEvent,
    editEvent
  }

  return (
    <NewEventContext.Provider value={value}>
      {children}
    </NewEventContext.Provider>
  )
}

export { NewEventProvider, useNewEvent };